module.exports = __webpack_public_path__ + "img/friendly-pool-6.b29d9ac4.jpg";